import React, {useState, useEffect, FormEvent} from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    TextInput,
    ImageInput,
    ImageField,
    required, BooleanInput, useChoicesContext, AutocompleteInput
} from 'react-admin';
import { nokStatus, genders, nokPersonaAgeRanges } from "../../defaults/defaults";
import {Box, Button, CircularProgress} from "@mui/material";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const STEP = 50; // how many extra records to pull in per click



const LoadMoreAutocomplete = (props) => {
    const { perPage, setPerPage, isFetching, hasNextPage } = useChoicesContext();

    return (
        <Box sx={ { width: '100%' } }>
            <AutocompleteInput {...props} />
            {hasNextPage && (
                <Button
                    size="small"
                    disabled={isFetching}
                    onClick={() => setPerPage(perPage + STEP)}
                >
                    {isFetching ? <CircularProgress size={16} /> : 'Load more'}
                </Button>
            )}
        </Box>
    );
};

export const NokPersonaCreate = () => {


    return (
        <Create redirect="edit">
            <SimpleForm >
                <TextInput source="name" />
                <TextInput source="email" />
                <SelectInput source="gender" choices={ genders } validate={ [required()] } />
                <SelectInput source="ageRange" label="Age Range" choices={ nokPersonaAgeRanges } validate={ [required()] } />
                <TextInput source="persona" multiline rows={5} />
                <ReferenceInput source="nokWebsite" reference="nok_websites">
                    <LoadMoreAutocomplete />
                </ReferenceInput>
                <TextInput source="phoneNumber"
                           helperText="This will be added to the persona signature if applicable" />
                <ImageInput source="image"
                            label="Persona Personal Image"
                            helperText="This image needs to be on the Nok site server to render in email footer and will display in the persona signature if applicable" >
                    <ImageField source="src" title="title" />
                </ImageInput>
                <TextInput source="productionImagePath" />
                <SelectInput source="status" choices={ nokStatus } defaultValue="active" validate={ [required()] } />
                <BooleanInput source="disableHtmlEmail" label="Disable HTML emails"/>
                <TextInput source="jobTitle" label="Job Title" helperText="Job Title for persona at connected Noks" />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
